import React, { useEffect, useState } from 'react';
import {
    FormattedMessage,
    WrappedComponentProps,
    injectIntl,
    useIntl,
} from 'react-intl';
/*models*/
import {
    IOrderDetails,
    IOrderEvent,
    IOrderHub,
} from '../../../../models/order';
import {
    IOrderStatuses,
    IStatusLevels,
} from '../../../../models/order-statuses';
import * as CON from '../../../common/constants';
/*CSS*/
import './order-tracker-styles.css';

interface IEventMessaging {
    orderEvent: IOrderEvent;
    orderStatus: IOrderStatuses;
    cancelled: boolean;
    currentEvent: IOrderHub;
}

export const EventMessaging = ({
    orderEvent,
    orderStatus,
    cancelled,
    currentEvent,
}: IEventMessaging) => {
    const intl = useIntl();
    //to do for future enhancement:
    // update these string arrays to also include exception level for each event
    const [orderingIds, setOrderingIds] = useState<string[]>([]);
    const [orderingMessages, setOrderingMessages] = useState<string[]>([]);
    const [processingIds, setProcessingIds] = useState<string[]>([]);
    const [processingMessages, setProcessingMessages] = useState<string[]>([]);
    const [shippingIds, setShippingIds] = useState<string[]>([]);
    const [shippingMessages, setShippingMessages] = useState<string[]>([]);
    const [outForDeliveryIds, setOutForDeliveryIds] = useState<string[]>([]);
    const [outForDeliveryMessages, setOutForDeliveryMessages] = useState<
        string[]
    >([]);
    useEffect(() => {
        if (
            currentEvent.caT_Description === 'Order details no longer available'
        ) {
            setOutForDeliveryMessages((outForDeliveryMessages) => [
                ...outForDeliveryMessages,
                'Order details no longer available',
            ]);
        } else {
            orderEvent.hubOrderDetails.map((x) => {
                if (x.eventCatagory === CON.ORDERING) {
                    if (x.caT_DescriptionId && x.caT_DescriptionId !== '') {
                        setOrderingIds((orderingIds) => [
                            ...orderingIds,
                            x.caT_DescriptionId,
                        ]);
                    }

                    if (x.caT_Description && x.caT_Description !== '') {
                        setOrderingMessages((orderingMessages) => [
                            ...orderingMessages,
                            x.caT_Description,
                        ]);
                    }
                }
                if (x.eventCatagory === CON.PROCESSING) {
                    if (x.caT_DescriptionId && x.caT_DescriptionId !== '') {
                        setProcessingIds((processingIds) => [
                            ...processingIds,
                            x.caT_DescriptionId,
                        ]);
                    }

                    if (x.caT_Description && x.caT_Description !== '') {
                        setProcessingMessages((processingMessages) => [
                            ...processingMessages,
                            x.caT_Description,
                        ]);
                    }
                }
                if (x.eventCatagory === CON.SHIPPING) {
                    if (x.caT_DescriptionId && x.caT_DescriptionId !== '') {
                        setShippingIds((shippingIds) => [
                            ...shippingIds,
                            x.caT_DescriptionId,
                        ]);
                    }

                    if (x.caT_Description && x.caT_Description !== '') {
                        setShippingMessages((shippingMessages) => [
                            ...shippingMessages,
                            x.caT_Description,
                        ]);
                    }
                }
                if (x.eventCatagory === CON.OUT_FOR_DELIVERY) {
                    if (x.caT_DescriptionId && x.caT_DescriptionId !== '') {
                        setOutForDeliveryIds((outForDeliveryIds) => [
                            ...outForDeliveryIds,
                            x.caT_DescriptionId,
                        ]);

                        if (x.caT_Description && x.caT_Description !== '') {
                            setOutForDeliveryMessages(
                                (outForDeliveryMessages) => [
                                    ...outForDeliveryMessages,
                                    x.caT_Description,
                                ]
                            );
                        }
                    }
                }
            });
        }
    }, []);

    const showEventMessaging = () => {
        if (
            orderStatus.ordering.isActive &&
            orderingIds.length !== 0 &&
            orderingMessages.length !== 0
        ) {
            return true;
        } else if (
            orderStatus.processing.isActive &&
            processingIds.length !== 0
        ) {
            return true;
        } else if (orderStatus.shipping.isActive && shippingIds.length !== 0) {
            return true;
        } else if (
            (orderStatus.outForDelivery.isActive ||
                orderStatus.outForDelivery.isCompleted) &&
            (outForDeliveryIds.length !== 0 ||
                outForDeliveryMessages.length !== 0)
        ) {
            return true;
        }
        return false;
    };
    const getStyle = (
        status: IStatusLevels,
        id: string,
        category: string,
        isMsg: boolean
    ) => {
        if (cancelled) {
            return isMsg
                ? 'p-msg red font-size-medium'
                : 'p-id red font-size-medium';
        } else if (status.isCompleted) {
            return isMsg
                ? 'p-msg id-completed font-size-medium'
                : 'p-id id-completed font-size-medium';
        } else {
            switch (category) {
                case CON.ORDERING:
                    if (id === orderingIds[orderingIds.length - 1]) {
                        return 'p-id id-active font-size-medium';
                    } else if (
                        id === orderingMessages[orderingMessages.length - 1]
                    ) {
                        return 'p-msg msg-active font-size-medium';
                    }
                    break;
                case CON.PROCESSING:
                    if (id === processingIds[processingIds.length - 1]) {
                        return 'p-id id-active font-size-medium';
                    } else if (
                        id === processingMessages[processingMessages.length - 1]
                    ) {
                        return 'p-msg msg-active font-size-medium';
                    }
                    break;
                case CON.SHIPPING:
                    if (id === shippingIds[shippingIds.length - 1]) {
                        return 'p-id id-active font-size-medium';
                    } else if (
                        id === shippingMessages[shippingMessages.length - 1]
                    ) {
                        return 'p-msg msg-active font-size-medium';
                    }

                    break;
                case CON.OUT_FOR_DELIVERY:
                    if (
                        id === outForDeliveryIds[outForDeliveryIds.length - 1]
                    ) {
                        return 'p-id id-active font-size-medium';
                    } else if (
                        id ===
                        outForDeliveryMessages[
                            outForDeliveryMessages.length - 1
                        ]
                    ) {
                        return 'p-msg msg-active font-size-medium';
                    }
                    break;

                default:
                    break;
            }
            return isMsg
                ? 'p-msg id-completed font-size-medium'
                : 'p-id id-completed font-size-medium';
        }
    };
    const getCheckMark = (
        isCompleted: boolean,
        id: string,
        category: string
    ) => {
        if (isCompleted) {
            return true;
        } else if (cancelled) {
            return false;
        } else {
            switch (category) {
                case CON.ORDERING:
                    if (id === orderingIds[orderingIds.length - 1]) {
                        return false;
                    }
                    break;
                case CON.PROCESSING:
                    if (id === processingIds[processingIds.length - 1]) {
                        return false;
                    }
                    break;
                case CON.SHIPPING:
                    if (id === shippingIds[shippingIds.length - 1]) {
                        return false;
                    }
                    break;
                case CON.OUT_FOR_DELIVERY:
                    if (id === shippingIds[outForDeliveryIds.length - 1]) {
                        return false;
                    }
                    break;
                default:
                    break;
            }
            return true;
        }
    };

    const getArrow = (isCompleted: boolean, id: string, category: string) => {
        if (cancelled || isCompleted) {
            return false;
        } else {
            switch (category) {
                case CON.ORDERING:
                    if (id === orderingIds[orderingIds.length - 1]) {
                        return true;
                    }
                    break;
                case CON.PROCESSING:
                    if (id === processingIds[processingIds.length - 1]) {
                        return true;
                    }
                    break;
                case CON.SHIPPING:
                    if (id === shippingIds[shippingIds.length - 1]) {
                        return true;
                    }
                    break;
                case CON.OUT_FOR_DELIVERY:
                    if (
                        id === outForDeliveryIds[outForDeliveryIds.length - 1]
                    ) {
                        return true;
                    }
                    break;
                default:
                    break;
            }
            return false;
        }
    };

    return (
        <>
            {showEventMessaging() ? (
                <div
                    className={
                        cancelled
                            ? 'event-messaging border-red'
                            : 'event-messaging'
                    }
                    id="event-messaging"
                >
                    {orderStatus.ordering.isActive &&
                        orderingIds.length !== 0 && (
                            <>
                                <div className="msg-id-div">
                                    {orderingIds.map((id, i) => (
                                        <React.Fragment key={i}>
                                            <div className="p-id-div">
                                                {getCheckMark(
                                                    orderStatus.ordering
                                                        .isCompleted,
                                                    id,
                                                    CON.ORDERING
                                                ) && (
                                                    <span>
                                                        <i className="id-check fas fa-check-circle fa-lg"></i>
                                                    </span>
                                                )}

                                                {getArrow(
                                                    orderStatus.ordering
                                                        .isCompleted,
                                                    id,
                                                    CON.ORDERING
                                                ) && (
                                                    <span>
                                                        <i className="blue fas fa-arrow-right fa-lg"></i>
                                                    </span>
                                                )}

                                                <p
                                                    className={getStyle(
                                                        orderStatus.ordering,
                                                        id,
                                                        CON.ORDERING,
                                                        false
                                                    )}
                                                >
                                                    {intl.formatMessage({
                                                        id: id.replace(
                                                            / /g,
                                                            '_'
                                                        ),
                                                        defaultMessage: id,
                                                    })}
                                                    {': '}
                                                </p>
                                            </div>
                                        </React.Fragment>
                                    ))}
                                </div>
                                <div className="msg-div">
                                    {orderingMessages.map((msg) => (
                                        <React.Fragment key={msg}>
                                            <p
                                                className={getStyle(
                                                    orderStatus.ordering,
                                                    msg,
                                                    CON.ORDERING,
                                                    true
                                                )}
                                            >
                                                {intl.formatMessage({
                                                    id: msg.replace(/ /g, '_'),
                                                    defaultMessage: msg,
                                                })}
                                            </p>
                                        </React.Fragment>
                                    ))}
                                </div>
                            </>
                        )}
                    {/** 
            {orderStatus.ordering.isActive && orderingIds.length === 0 && (
                <div className="no-messages-available">
                    <h1>
                        {intl.formatMessage({
                            id: CON.NO_AVAILABLE_ID,
                            defaultMessage: CON.NO_AVAIABLE
                        })}
                    </h1>
                </div>
            )}
                    */}
                    {orderStatus.processing.isActive &&
                        processingIds.length !== 0 && (
                            <>
                                <div className="msg-id-div">
                                    {processingIds.map((id, i) => (
                                        <React.Fragment key={i}>
                                            <div className="p-id-div">
                                                {getCheckMark(
                                                    orderStatus.processing
                                                        .isCompleted,
                                                    id,
                                                    CON.PROCESSING
                                                ) && (
                                                    <span>
                                                        <i className="id-check fas fa-check-circle fa-lg"></i>
                                                    </span>
                                                )}

                                                {getArrow(
                                                    orderStatus.processing
                                                        .isCompleted,
                                                    id,
                                                    CON.PROCESSING
                                                ) && (
                                                    <span>
                                                        <i className="blue fas fa-arrow-right fa-lg"></i>
                                                    </span>
                                                )}
                                                <p
                                                    className={getStyle(
                                                        orderStatus.processing,
                                                        id,
                                                        CON.PROCESSING,
                                                        false
                                                    )}
                                                >
                                                    {intl.formatMessage({
                                                        id: id.replace(
                                                            / /g,
                                                            '_'
                                                        ),
                                                        defaultMessage: id,
                                                    })}
                                                    {': '}
                                                </p>
                                            </div>
                                        </React.Fragment>
                                    ))}
                                </div>
                                <div className="msg-div">
                                    {processingMessages.map((msg) => (
                                        <React.Fragment key={msg}>
                                            <p
                                                className={getStyle(
                                                    orderStatus.processing,
                                                    msg,
                                                    CON.PROCESSING,
                                                    true
                                                )}
                                            >
                                                {intl.formatMessage({
                                                    id: msg.replace(/ /g, '_'),
                                                    defaultMessage: msg,
                                                })}
                                            </p>
                                        </React.Fragment>
                                    ))}
                                </div>
                            </>
                        )}
                    {/** 
            {orderStatus.processing.isActive && processingIds.length === 0 && (
                <div className="no-messages-available">
                    <h1>
                        {intl.formatMessage({
                            id: CON.NO_AVAILABLE_ID,
                            defaultMessage: CON.NO_AVAIABLE
                        })}
                    </h1>
                </div>
            )}
            */}
                    {orderStatus.shipping.isActive &&
                        shippingIds.length !== 0 && (
                            <>
                                <div className="msg-id-div">
                                    {shippingIds.map((id, i) => (
                                        <React.Fragment key={i}>
                                            <div className="p-id-div">
                                                {getCheckMark(
                                                    orderStatus.shipping
                                                        .isCompleted,
                                                    id,
                                                    CON.SHIPPING
                                                ) && (
                                                    <span>
                                                        <i className="id-check fas fa-check-circle fa-lg"></i>
                                                    </span>
                                                )}

                                                {getArrow(
                                                    orderStatus.shipping
                                                        .isCompleted,
                                                    id,
                                                    CON.SHIPPING
                                                ) && (
                                                    <span>
                                                        <i className="blue fas fa-arrow-right fa-lg"></i>
                                                    </span>
                                                )}
                                                <p
                                                    className={getStyle(
                                                        orderStatus.shipping,
                                                        id,
                                                        CON.SHIPPING,
                                                        false
                                                    )}
                                                >
                                                    {intl.formatMessage({
                                                        id: id.replace(
                                                            / /g,
                                                            '_'
                                                        ),
                                                        defaultMessage: id,
                                                    })}
                                                    {': '}
                                                </p>
                                            </div>
                                        </React.Fragment>
                                    ))}
                                </div>
                                <div className="msg-div">
                                    {shippingMessages.map((msg) => (
                                        <React.Fragment key={msg}>
                                            <p
                                                className={getStyle(
                                                    orderStatus.shipping,
                                                    msg,
                                                    CON.SHIPPING,
                                                    true
                                                )}
                                            >
                                                {intl.formatMessage({
                                                    id: msg.replace(/ /g, '_'),
                                                    defaultMessage: msg,
                                                })}
                                            </p>
                                        </React.Fragment>
                                    ))}
                                </div>
                            </>
                        )}
                    {/** 
            {orderStatus.shipping.isActive && shippingIds.length === 0 && (
                <div className="no-messages-available">
                    <h1>
                        {intl.formatMessage({
                            id: CON.NO_AVAILABLE_ID,
                            defaultMessage: CON.NO_AVAIABLE
                        })}
                    </h1>
                </div>
            )}
            */}
                    {(orderStatus.outForDelivery.isActive ||
                        orderStatus.outForDelivery.isCompleted) &&
                        (outForDeliveryIds.length !== 0 ||
                            outForDeliveryMessages.length !== 0) && (
                            <>
                                <div className="msg-id-div">
                                    {outForDeliveryIds.map((id, i) => (
                                        <React.Fragment key={i}>
                                            <div className="p-id-div">
                                                {getCheckMark(
                                                    orderStatus.outForDelivery
                                                        .isCompleted,
                                                    id,
                                                    CON.OUT_FOR_DELIVERY
                                                ) && (
                                                    <span>
                                                        <i className="id-check fas fa-check-circle fa-lg"></i>
                                                    </span>
                                                )}

                                                {getArrow(
                                                    orderStatus.outForDelivery
                                                        .isCompleted,
                                                    id,
                                                    CON.OUT_FOR_DELIVERY
                                                ) && (
                                                    <span>
                                                        <i className="blue fas fa-check-circle fa-lg"></i>
                                                    </span>
                                                )}
                                                <p
                                                    className={getStyle(
                                                        orderStatus.outForDelivery,
                                                        id,
                                                        CON.OUT_FOR_DELIVERY,
                                                        false
                                                    )}
                                                >
                                                    {intl.formatMessage({
                                                        id: id.replace(
                                                            / /g,
                                                            '_'
                                                        ),
                                                        defaultMessage: id,
                                                    })}
                                                    {': '}
                                                </p>
                                            </div>
                                        </React.Fragment>
                                    ))}
                                </div>
                                <div className="msg-div">
                                    {outForDeliveryMessages.map((msg) => (
                                        <React.Fragment key={msg}>
                                            <p
                                                className={getStyle(
                                                    orderStatus.outForDelivery,
                                                    msg,
                                                    CON.OUT_FOR_DELIVERY,
                                                    true
                                                )}
                                            >
                                                {intl.formatMessage({
                                                    id: msg.replace(/ /g, '_'),
                                                    defaultMessage: msg,
                                                })}
                                            </p>
                                        </React.Fragment>
                                    ))}
                                </div>
                            </>
                        )}
                    {/**
            {orderStatus.outForDelivery.isActive &&
                outForDeliveryIds.length === 0 && (
                    <div className="no-messages-available">
                        <h1>
                            {intl.formatMessage({
                                id: CON.NO_AVAILABLE_ID,
                                defaultMessage: CON.NO_AVAIABLE
                            })}
                        </h1>
                    </div>
                )}
                */}
                </div>
            ) : (
                <></>
            )}
        </>
    );
};

export default EventMessaging;
